export function onDomReady(callback) {
  if (document.readyState === "loading") {
    function handleDomReady() {
      document.removeEventListener("DOMContentLoaded", handleDomReady);
      callback();
    }

    document.addEventListener("DOMContentLoaded", handleDomReady);
  } else {
    callback();
  }
}
